import { toIso8601 } from '@utils/date';

import clock from '@plugins/dayjs';
import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';

export class DateValidator extends BaseValidator {
    static key = 'date';

    static validator(value, label = 'Date') {
        if (!value) {
            return true;
        }

        value = clock(toIso8601(value));

        if (!value || !value.isValid()) {
            return i18n.t('validator.date', { field: label });
        }

        return true;
    }

    static arguments() {
        return [];
    }
}

export default DateValidator;
